import { jsx as _jsx } from "react/jsx-runtime";
var Calendar = function Calendar(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.10718 16C7.10718 15.45 7.55718 15 8.10718 15C8.65718 15 9.10718 15.45 9.10718 16C9.10718 16.55 8.65718 17 8.10718 17C7.55718 17 7.10718 16.55 7.10718 16ZM12.1072 15H16.1072C16.6572 15 17.1072 15.45 17.1072 16C17.1072 16.55 16.6572 17 16.1072 17H12.1072C11.5572 17 11.1072 16.55 11.1072 16C11.1072 15.45 11.5572 15 12.1072 15ZM18.1072 20H6.10718C5.55618 20 5.10718 19.551 5.10718 19V13H19.1072V19C19.1072 19.551 18.6582 20 18.1072 20ZM6.10718 6H7.10718V7C7.10718 7.55 7.55718 8 8.10718 8C8.65718 8 9.10718 7.55 9.10718 7V6H15.1072V7C15.1072 7.55 15.5572 8 16.1072 8C16.6572 8 17.1072 7.55 17.1072 7V6H18.1072C18.6582 6 19.1072 6.449 19.1072 7V11H5.10718V7C5.10718 6.449 5.55618 6 6.10718 6ZM18.1072 4H17.1072V3C17.1072 2.45 16.6572 2 16.1072 2C15.5572 2 15.1072 2.45 15.1072 3V4H9.10718V3C9.10718 2.45 8.65718 2 8.10718 2C7.55718 2 7.10718 2.45 7.10718 3V4H6.10718C4.45318 4 3.10718 5.346 3.10718 7V19C3.10718 20.654 4.45318 22 6.10718 22H18.1072C19.7612 22 21.1072 20.654 21.1072 19V7C21.1072 5.346 19.7612 4 18.1072 4Z",
      fill: color
    })
  });
};
export default Calendar;